import { z } from "zod";
const analyticsEventData = {
  "page-view": z.object({
    to: z.string(),
    from: z.string(),
    hostname: z.string()
  })
};
const analyticsEvents = Object.keys(analyticsEventData);
const analyticsEventEnum = z.enum(analyticsEvents);
export {
  analyticsEventData,
  analyticsEventEnum,
  analyticsEvents
};
//# sourceMappingURL=events.js.map
